//rest/mp/auth/wx/commoncode
import { config } from "../utils/config";
import { omniAxios } from "../utils/axios";
export function restMpAuthWxCommoncode(params) {
  return omniAxios({
    url: config.restMpAuthWxCommoncodePath,
    method: "get",
    params,
    isOnePointZeroWWWInterfaceApi: true,
    useDevServerProxy: true,
    setToken: false,
  });
}